import script from "./ArticleItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleItem.vue?vue&type=script&setup=true&lang=js"

import "./ArticleItem.vue?vue&type=style&index=0&id=1b99a76d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b99a76d"]])

export default __exports__